import { createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29501c22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sm:hidden flex justify-content-center" }
const _hoisted_2 = { class: "w-full flex align-items-start sm:align-items-center justify-content-between gap-2 mt-4" }
const _hoisted_3 = { class: "flex gap-4 align-items-center" }
const _hoisted_4 = { class: "flex flex-column gap-4" }
const _hoisted_5 = { class: "text-xl font-bold sm:text-primary" }
const _hoisted_6 = {
  key: 0,
  class: "block text-lg text-gray-500 mt-2"
}
const _hoisted_7 = { class: "wp1200 pb-2 px-2 sm:py-0 text-900" }
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = {
  key: 0,
  class: "block sm:hidden text-lg font-semibold mt-2"
}
const _hoisted_10 = {
  key: 1,
  class: "block sm:hidden font-semibold"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "flex flex-column sm:flex-row sm:align-items-center sm:justify-content-start gap-2 sm:gap-5 flex-wrap" }
const _hoisted_13 = {
  key: 0,
  class: "hidden sm:block mt-3 mb-2"
}
const _hoisted_14 = { class: "text-lg font-semibold mr-2" }
const _hoisted_15 = { class: "text-2xl font-bold" }
const _hoisted_16 = {
  key: 1,
  class: "hidden sm:block mt-3 mb-2"
}
const _hoisted_17 = { class: "text-lg font-semibold mr-2" }
const _hoisted_18 = { class: "text-2xl font-bold" }
const _hoisted_19 = {
  key: 2,
  class: "block sm:hidden"
}
const _hoisted_20 = { class: "text-lg font-semibold mr-2" }
const _hoisted_21 = {
  key: 3,
  class: "block sm:hidden"
}
const _hoisted_22 = { class: "text-lg font-semibold mr-2" }
const _hoisted_23 = {
  key: 5,
  class: "flex gap-4"
}
const _hoisted_24 = {
  key: 0,
  class: "flex align-items-center gap-2"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_car text-xl" }, null, -1))
const _hoisted_26 = { class: "sm:text-2xl font-semibold" }
const _hoisted_27 = {
  key: 1,
  class: "flex align-items-center gap-2"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_el-polnilnica" }, null, -1))
const _hoisted_29 = { class: "sm:text-2xl font-semibold" }
const _hoisted_30 = {
  key: 2,
  class: "flex align-items-center gap-2"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_invalid" }, null, -1))
const _hoisted_32 = { class: "sm:text-2xl font-semibold" }
const _hoisted_33 = {
  key: 6,
  class: "flex gap-4"
}
const _hoisted_34 = {
  key: 0,
  class: "flex align-items-center gap-2"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_car" }, null, -1))
const _hoisted_36 = { class: "sm:text-2xl font-semibold" }
const _hoisted_37 = {
  key: 1,
  class: "flex align-items-center gap-2"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_el-polnilnica" }, null, -1))
const _hoisted_39 = { class: "sm:text-2xl font-semibold" }
const _hoisted_40 = {
  key: 2,
  class: "flex align-items-center gap-2"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_invalid" }, null, -1))
const _hoisted_42 = { class: "sm:text-2xl font-semibold" }
const _hoisted_43 = { class: "flex flex-column sm:flex-row mb-5 sm:pt-5 gap-4" }
const _hoisted_44 = {
  key: 0,
  class: "oneColumn"
}
const _hoisted_45 = { class: "infoCard" }
const _hoisted_46 = { class: "block text-lg font-bold mb-4" }
const _hoisted_47 = { class: "flex justify-content-between text-lg gap-3" }
const _hoisted_48 = {
  key: 2,
  class: "oneColumn"
}
const _hoisted_49 = { class: "infoCard" }
const _hoisted_50 = { class: "block text-lg font-bold mb-4" }
const _hoisted_51 = { class: "flex justify-content-between text-lg gap-3" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = {
  key: 3,
  class: "oneColumn"
}
const _hoisted_55 = { class: "infoCard" }
const _hoisted_56 = { class: "block text-lg font-bold mb-4" }
const _hoisted_57 = { class: "table" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-R" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FavouriteButton = _resolveComponent("FavouriteButton")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createBlock(_component_Sidebar, {
    visible: true,
    dismissable: false,
    position: "bottom",
    modal: false,
    "show-close-icon": false,
    class: "bottomSheet"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "handle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ParkingMap' })))
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("i", {
            tabindex: "0",
            class: "hidden sm:block icon-warpit_icon_arrow-L font-bold text-xl text-gray-500 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = () => _ctx.goBack()),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(() => _ctx.goBack(), ["enter"]))
          }, null, 32),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.parking.name), 1),
              (_ctx.parking.address)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.parking.address), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.user)
          ? (_openBlock(), _createBlock(_component_FavouriteButton, {
              key: 0,
              item: _ctx.parking,
              onSetFavourite: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('setFavourite')))
            }, null, 8, ["item"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (
            _ctx.parking.smart === 1 &&
            _ctx.checkAvailability(_ctx.parking) === true &&
            _ctx.totalAvailableSmartParking >= 0
          )
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("parking.info.all_available_smart")) + ": " + _toDisplayString(_ctx.totalAvailableSmartParking), 1))
            : (_ctx.parking.smart === 0 && _ctx.checkAvailability(_ctx.parking) === true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("parking.info.all_available")) + ": " + _toDisplayString(_ctx.totalAvailableParking), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("parking.no_spaces")), 1)),
          _createVNode(_component_Divider, { class: "mb-4" }),
          _createElementVNode("div", _hoisted_12, [
            (
              _ctx.parking.smart === 1 &&
              _ctx.checkAvailability(_ctx.parking) === true &&
              _ctx.totalAvailableSmartParking >= 0
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("parking.info.all_available_smart")) + ":", 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.totalAvailableSmartParking), 1)
                ]))
              : (
              _ctx.parking.smart === 0 && _ctx.checkAvailability(_ctx.parking) === true
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("parking.info.all_available")) + ":", 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.totalAvailableParking), 1)
                  ]))
                : _createCommentVNode("", true),
            (
              _ctx.parking.smart === 1 &&
              _ctx.checkAvailability(_ctx.parking) === true &&
              _ctx.totalAvailableSmartParking >= 0
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("parking.card.available_smart")) + ":", 1)
                ]))
              : (
              _ctx.parking.smart === 0 && _ctx.checkAvailability(_ctx.parking) === true
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("parking.card.available")) + ":", 1)
                  ]))
                : _createCommentVNode("", true),
            (
              (_ctx.parking.smart === 0 &&
                _ctx.totalAvailableParking >= 0 &&
                _ctx.checkAvailability(_ctx.parking) === true) ||
              (_ctx.parking.smart === 1 &&
                _ctx.checkAvailability(_ctx.parking) === true &&
                _ctx.totalAvailableSmartParking >= 0)
            )
              ? (_openBlock(), _createBlock(_component_Divider, {
                  key: 4,
                  layout: "vertical",
                  class: "hidden sm:block"
                }))
              : _createCommentVNode("", true),
            (
              _ctx.parking.smart === 1 &&
              _ctx.checkAvailability(_ctx.parking) === true &&
              _ctx.totalAvailableSmartParking >= 0
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_ctx.parking.spaces_regular)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.parking.spaces_regular - _ctx.parking.spaces_regular_occupied) + "/" + _toDisplayString(_ctx.parking.spaces_regular), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.parking.spaces_ev)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.parking.spaces_ev - _ctx.parking.spaces_ev_occupied) + "/" + _toDisplayString(_ctx.parking.spaces_ev), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.parking.spaces_accessible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.parking.spaces_accessible -
                  _ctx.parking.spaces_accessible_occupied) + "/" + _toDisplayString(_ctx.parking.spaces_accessible), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (
              _ctx.parking.smart === 0 && _ctx.checkAvailability(_ctx.parking) === true
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    (_ctx.parking.spaces_regular)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.parking.spaces_regular), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.parking.spaces_ev)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _hoisted_38,
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.parking.spaces_ev), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.parking.spaces_accessible)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.parking.spaces_accessible), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
          ]),
          (
            (_ctx.parking.smart === 0 &&
              _ctx.totalAvailableParking >= 0 &&
              _ctx.checkAvailability(_ctx.parking) === true) ||
            (_ctx.parking.smart === 1 &&
              _ctx.checkAvailability(_ctx.parking) === true &&
              _ctx.totalAvailableSmartParking >= 0)
          )
            ? (_openBlock(), _createBlock(_component_Divider, {
                key: 3,
                class: "sm:hidden mb-4"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_43, [
            (
              _ctx.parking.working_hours !== null && _ctx.parking.working_hours.length > 0
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("parking.info.opening_hours")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parking.working_hours, (hours, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: hours.id
                      }, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.parseRRule(hours.recurrence)), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatTime(hours.open_time, hours.close_time)), 1)
                        ]),
                        (index < _ctx.parking.working_hours.length - 1)
                          ? (_openBlock(), _createBlock(_component_Divider, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (
              _ctx.parking.prices !== null &&
              _ctx.parking.prices.length > 0 &&
              _ctx.parking.working_hours !== null &&
              _ctx.parking.working_hours.length > 0
            )
              ? (_openBlock(), _createBlock(_component_Divider, {
                  key: 1,
                  class: "sm:hidden m-0"
                }))
              : _createCommentVNode("", true),
            (_ctx.parking.prices !== null && _ctx.parking.prices.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t("parking.info.price")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parking.prices, (price, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: price.id
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.parseRRule(price.recurrence)), 1),
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatTime(price.start_time, price.end_time)), 1),
                          (price.price === 0 || price.price === null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.$t("parking.free")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString((price.price / 100).toFixed(2) + " " + price.currency) + " / h", 1))
                        ]),
                        (index < _ctx.parking.prices.length - 1)
                          ? (_openBlock(), _createBlock(_component_Divider, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.evSpaces && _ctx.evSpaces.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t("parking.info.ev_chargers")), 1),
                    _createElementVNode("table", _hoisted_57, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.evSpaces, (space) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: space.id
                          }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("div", {
                                style: _normalizeStyle({
                          width: '12px',
                          height: '12px',
                          backgroundColor:
                            space.free === 1
                              ? 'var(--green-600)'
                              : 'var(--red-400)',
                          borderRadius: '50%',
                        })
                              }, null, 4)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(space.ev_connector_type), 1),
                            _createElementVNode("td", null, _toDisplayString(space.ev_connector_power), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_Divider),
          _createVNode(_component_Button, {
            class: "defaultButton flex align-items-center justify-content-between w-full px-4 sm:w-4 sm:mb-3",
            icon: "pi pi-arrow-right",
            iconPos: "right",
            onClick: _ctx.openGoogleMaps
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("parking.directions")) + " ", 1),
              _hoisted_58
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("button", {
            class: "hidden sm:block bg-transparent border-none text-black-alpha-50 text-lg underline cursor-pointer p-0",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goBack(true)))
          }, _toDisplayString(_ctx.$t("parking.info.back")), 1)
        ])
      ])
    ]),
    _: 1
  }))
}